import { consola } from 'consola'
import type { Session, RevokeSessionResponse, RevokeOthersResponse } from '../model/types'
import { useApi } from '@shared/api'

const logger = consola.withTag('api-session')

/**
 * API-клиент управления сессиями пользователя.
 * Базовый URL: /api/v2/auth/sessions
 */
class APISession {
  async getSessions(): Promise<Session[]> {
    logger.debug('Fetching user sessions')
    const response = await useApi(true).get('/auth/sessions')
    logger.success(`Received ${response.data?.length ?? 0} sessions`)
    return response.data as Session[]
  }

  async revokeSession(sessionId: string): Promise<RevokeSessionResponse> {
    logger.debug('Revoking session:', sessionId.slice(0, 8) + '…')
    const response = await useApi(true).delete(`/auth/sessions/${sessionId}`)
    logger.success('Session revoked:', sessionId.slice(0, 8) + '…')
    return response.data as RevokeSessionResponse
  }

  async revokeOthers(): Promise<RevokeOthersResponse> {
    logger.debug('Revoking all other sessions')
    const response = await useApi(true).delete('/auth/sessions/revoke-others')
    logger.success('Other sessions revoked:', { count: response.data?.revokedCount ?? 0 })
    return response.data as RevokeOthersResponse
  }

  async logoutAll(): Promise<void> {
    logger.warn('Logging out from all sessions')
    await useApi(true).delete('/auth/logout-all')
    logger.success('Logged out from all sessions')
  }
}

export const apiSession = new APISession()
export default apiSession
